<script setup>
import {onMounted} from "vue";

const props = defineProps({
    containerRef: {
        type: String,
        required: true
    },
    uuid: {
        type: String,
        require: true
    },
    content: {
        type: Object,
        required: true
    },
})

const triggerTagging = async () => {
    if (window.myflow.pagebuilderActive) {
        return;
    }

    if (!window.myflow.user?.loggedIn) {
        return;
    }

    const res = await axios.post(route('block-editor-container.blocks.tagging-block', {
        containerRef: props.containerRef,
        blockUuid: props.uuid,
    }))

    if( res.data.error ) {
        console.error(res.data.error);
    }
}

onMounted(() => {
    triggerTagging()
})


</script>

<template>
<div></div>
</template>
